<div class="animated fadeIn">
    <div class="col-md-12">
        <div class="card">
            <div class="card-content">
                <table-component (onView)="onView($event)"
                                 (onAdd)="onAdd()"
                                 (onRemove)="onRemove($event)"></table-component>
            </div>
        </div>
    </div>
</div>